<template functional>
  <a
    v-if="$options.DisplayValue(props) !== 0"
    href="#"
    @click="$options.Selected(props)"
  >
    {{ $options.DisplayValue(props) }}
  </a>
</template>

<script>
import { formatMonto } from "@/utils";
//import { formatterMoney } from "@/utils";

export default {
  name: "Hyperlink",
  Selected(props) {
    //console.log("PORPS LINK", props);
    props.OpenSelection(
      props.month,
      props.row,
      props.row.ExecutiveName,
      props.row
    );
  },

  DisplayValue(props) {
    //console.log("Entro al fromatMonto props: ", props);
    const type = props.getType();
    var _type = String;
    if (type === "Cantidad") {
      _type = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
      // console.log("if: ", _type);
    } else {
      _type = `${props.column}${type !== "Cantidad" ? "" : "Amount"}`;
      //  console.log("else: ", _type);
    }
    //console.log("Type: ", type);
    if (type === "Monto") {
      const MothValue = Number(props.row[_type]);
      if (MothValue > 0) {
        //console.log("Entro al fromatMonto");
        return formatMonto(MothValue);
      } else {
        return 0;
      }
    }
    /*
    if (type === "Cantidad") {
      const MothValue = Number(props.row[_type]);
      if (MothValue > 0) {
        //console.log("Entro al fromatMonto");
        return formatterMoney(MothValue);
      } else {
        return 0;
      }
    }
    */
    const MothValue = Number(props.row[_type]);
    if (Number(MothValue).toFixed(0) > 0) {
      return Number(MothValue).toFixed(0);
    } else {
      return null;
    }
  }
};
</script>
